module.exports = require("@seddi/three");